// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "client-viewer/" + ({"183":"OnImage","242":"CardsMobile","468":"Cards","528":"CompactMobile","545":"ListLayout","721":"SingleEvent","789":"Calendar","801":"EmptyState","932":"SideBySide"}[chunkId] || chunkId) + ".chunk.min.js";
};